export default __webpack_public_path__ + "static/media/18_shop-2.db105e72.jpg";